// extracted by mini-css-extract-plugin
module.exports = {"container":"_3UGPx7kBtIKQirzicqIsWw","icon":"_3swISIj6VXnhOOwy4p6Eny"};